import { render } from "./Edit.vue?vue&type=template&id=4c466af0&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=4c466af0&scoped=true&lang=css"

import exportComponent from "D:\\Git\\Nakhoncity\\Nakhoncity-App-Register\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c466af0"]])

export default __exports__